import { create } from "zustand";
import { TaskState } from "../../../interfaces/Projects/Catalogs/taskStates";


interface TaskStatesStore {
    taskStates: TaskState[];
    pendingTaskState: TaskState;
    doneTaskState: TaskState;
    setTaskStates: (by: TaskState[]) => void;
    addTaskState: (by: TaskState) => void;
    updateTaskState: (by: TaskState) => void;
    assignPendingAndDoneStates: () => void;
}

export const useTaskStatesStore = create<TaskStatesStore>()(
    (set, get) => ({
        taskStates: [],
        pendingTaskState: {},
        doneTaskState: {},
        setTaskStates: (by: TaskState[]) => {

            if (by.length === 0) {
                return;
            }

            set({ taskStates: by });
            get().assignPendingAndDoneStates();
        },
        addTaskState: (by: TaskState) => {
            set((state) => ({ taskStates: [...state.taskStates, by] }))
        },
        updateTaskState: (by: TaskState) => {
            set((state) => ({
                taskStates: state.taskStates.map((taskState) =>
                    taskState.task_state_id === by.task_state_id ? by : taskState
                ),
            }));
        },
        assignPendingAndDoneStates: () => {
            const { taskStates } = get();
            const pendingState = taskStates.find(state => state.task_state_name === "PENDING");
            const doneState = taskStates.find(state => state.task_state_name === "DONE");

            set({
                pendingTaskState: pendingState || {},
                doneTaskState: doneState || {},
            });
        },
    })
)